import { computeBulkDeleteReconnectOps } from '@chatsdet/workflow-diff';
import type { WorkflowEdge, WorkflowNode } from '../../../../types/workflow';

type ComputeOptimisticBulkDeleteGraphParams = {
  nodes: WorkflowNode[];
  edges: WorkflowEdge[];
  deleteNodeIds: string[];
  createEdgeId?: () => string;
};

export function computeOptimisticBulkDeleteGraph({
  nodes,
  edges,
  deleteNodeIds,
  createEdgeId = () => crypto.randomUUID(),
}: ComputeOptimisticBulkDeleteGraphParams): { nodes: WorkflowNode[]; edges: WorkflowEdge[] } {
  const deleteSet = new Set(deleteNodeIds);
  const reconnectEdges = computeBulkDeleteReconnectOps({
    edges: edges.map((edge) => ({
      id: edge.id,
      sourceNodeId: edge.source,
      targetNodeId: edge.target,
    })),
    deleteNodeIds,
    reconnect: true,
  }).reconnectEdges;

  const nextNodes = nodes.filter((node) => !deleteSet.has(node.id));
  const survivingEdges = edges.filter(
    (edge) => !deleteSet.has(edge.source) && !deleteSet.has(edge.target)
  );
  const bridgeEdges: WorkflowEdge[] = reconnectEdges.map((edge) => ({
    id: createEdgeId(),
    source: edge.sourceNodeId,
    target: edge.targetNodeId,
    type: 'default',
    edgeType: 'default',
  }));

  return { nodes: nextNodes, edges: [...survivingEdges, ...bridgeEdges] };
}
